import styled from 'styled-components';

import { RouterComponent_LinkWithStore as Link } from 'ggApp/modules/router';

export const Add = styled.div`
    margin: 30px 0;
`;

export const Text = styled.div`
    font-size: 16px;
    line-height: 1.35;
    letter-spacing: 0.3px;
    text-align: center;
    display: block;
`;

export const LinkText = styled(Link)`
    font-size: 16px;
    line-height: 1.35;
    letter-spacing: 0.3px;
    text-align: center;
    display: block;
    font-weight: 600;

    &:hover,
    &:active {
        color: #3d02ff;
    }
`;
